/* eslint-disable @typescript-eslint/no-empty-function */
import { FC } from 'react';
import { useBundleUpchargePriceDeviations } from '@/services/bundles/bundles.service';
import { PriceDeviationsDrawerShared } from '@/pages/Franchisee/SharedComponents/PriceDeviations/PriceDeviationsDrawerShared';
import { mapBundleUpchargeToPriceDeviationResponse } from './mapBundleUpchargeToPriceDeviationResponse';
import { BundleUpchargePriceDeviationDrawerProps } from './BundleUpchargePriceDeviationDrawerProps.types';

export const BundleUpchargesPriceDeviationDrawer: FC<BundleUpchargePriceDeviationDrawerProps> = ({
  isOpen,
  onClose,
  cameFromEditDrawer,
  type,
  groupId,
}) => {
  const { data, isLoading } = useBundleUpchargePriceDeviations(true, type, groupId);
  const tableData = mapBundleUpchargeToPriceDeviationResponse(data);
  const selectedGroupName = data?.storeGroupName ?? '';

  return (
    <PriceDeviationsDrawerShared
      isOpen={isOpen}
      onClose={onClose}
      selectedGroupName={selectedGroupName}
      data={tableData}
      isLoading={isLoading}
      cameFromEditDrawer={cameFromEditDrawer}
      formatZeroPriceAsNone
    />
  );
};
export default BundleUpchargesPriceDeviationDrawer;
